import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

// T-261 — Promemoria controllo temperature: 1 controllo al giorno (modello
// scheda Cambusa, frigoriferi + congelatori). Un solo promemoria giornaliero
// se ci sono unità da controllare.
//
// Solo nativo (Android/iOS): su web/PWA LocalNotifications non è affidabile.

const DAILY_ID = 777013;
// id dei vecchi 3 promemoria a fasce (T-247) da cancellare in upgrade.
const LEGACY_IDS = [777010, 777011, 777012];
const GUARD_KEY = 'trackeat.temperature_reminder_v2';

async function ensurePermission(): Promise<boolean> {
  const cur = await LocalNotifications.checkPermissions();
  if (cur.display === 'granted') return true;
  const req = await LocalNotifications.requestPermissions();
  return req.display === 'granted';
}

/**
 * Schedula (o cancella) il promemoria giornaliero del controllo temperature.
 * Best-effort: non lancia MAI verso il chiamante.
 * - hasFridges true  → 1 notifica ricorrente alle 18:00 (creata una volta per
 *   installazione; cancella prima i 3 vecchi promemoria a fasce).
 * - hasFridges false → cancella tutto.
 */
export async function scheduleTemperatureReminders(opts: { hasFridges: boolean }): Promise<void> {
  try {
    if (!Capacitor.isNativePlatform()) return;
    // Upgrade da T-247: rimuovi i 3 promemoria a fasce.
    try { await LocalNotifications.cancel({ notifications: LEGACY_IDS.map((id) => ({ id })) }); } catch { /* */ }

    if (!opts.hasFridges) {
      try { await LocalNotifications.cancel({ notifications: [{ id: DAILY_ID }] }); } catch { /* */ }
      try { localStorage.removeItem(GUARD_KEY); } catch { /* */ }
      return;
    }
    if (!(await ensurePermission())) return;

    let already = false;
    try { already = localStorage.getItem(GUARD_KEY) !== null; } catch { already = false; }
    if (already) return;

    await LocalNotifications.schedule({
      notifications: [{
        id: DAILY_ID,
        title: 'TrackEAT — Controllo temperature',
        body: 'Registra il controllo temperature di frigoriferi e congelatori di oggi.',
        schedule: { on: { hour: 18, minute: 0 }, repeats: true, allowWhileIdle: true },
      }],
    });
    try { localStorage.setItem(GUARD_KEY, new Date().toISOString()); } catch { /* */ }
  } catch {
    // best-effort
  }
}
